import { defineMessages } from 'react-intl';

export default defineMessages({
  waitlistCardWaitlistPositionText: {
    id: 'waitlist.CardWaitlistPositionText',
    defaultMessage: "Waitlist Position",
    description: 'Label for the waitlist position',
  },
  waitlistCardPriorityGroupText: {
    id: 'waitlist.CardPriorityGroupText',
    defaultMessage: "Priority Group",
    description: 'Label for the priority group',
  },
  waitlistCardStartDateText: {
    id: 'waitlist.CardStartDateText',
    defaultMessage: "Start Date",
    description: 'Label for the start date',
  },
  waitlistCardWaitlistInformationText: {
    id: 'waitlist.CardWaitlistInformationText',
    defaultMessage: "Waitlist Information",
    description: 'Label for the waitlist information',
  },
});
